<template>
    <div class="d-flex w-100">
        <input
            :placeholder="placeholder"
            class="bg-lighter flexGrow1"
            :value="value"
            @input="$emit('input', $event.target.value)"
            @keyup.enter="$emit('search')"
            type="text"
        />
        <button class="btn wider blue ml-3 w-80" @click="$emit('search')">Search</button>
    </div>
</template>

<script>
    export default {
        name: 'ReservationsSearchBar',
        props: {
        value: { type: String, default: '' },
        placeholder: { type: String, default: 'Search customer, ticket, voucher' }
        }
    }
</script>



// WEBPACK FOOTER //
// ReservationsSearchBar.vue?49cb2394